/* ============================================================
 * nv-collection.js - pagina de colecao (sections/nv-collection.liquid)
 * - gaveta/painel de ordenar e filtros
 * - filtros, ordenacao e "carregar mais" sem recarregar a pagina
 *   (Section Rendering API); sem JS tudo segue funcionando por link/form
 * - barra de filtros fixa logo abaixo do cabecalho
 * Carrinho/favoritos: delegacao global do nova-home.js.
 * Ajuste das fotos: nv-img-fit.js (observa o DOM sozinho).
 * ============================================================ */
(function () {
  'use strict';

  function cleanUrl(href) {
    var u = new URL(href, window.location.origin);
    u.searchParams.delete('section_id');
    return u;
  }

  function sectionUrl(u, id) {
    var s = new URL(u.toString());
    s.searchParams.set('section_id', id);
    return s.toString();
  }

  /* ---------- barra fixa abaixo do cabecalho ---------- */
  function offsetTop() {
    var bar = document.querySelector('.nv-appbar');
    if (!bar) return 0;
    var r = bar.getBoundingClientRect();
    return r.top <= 1 && r.bottom > 0 ? Math.round(r.bottom) : 0;
  }

  function init(root) {
    if (!root || root._nvCol) return;
    root._nvCol = true;
    var id = root.dataset.sectionId;
    var lastFocus = null;
    var busy = false;

    /* ---------- gaveta ---------- */
    function openSheet(sheetId, opener) {
      closeSheet(true);
      var sheet = document.getElementById(sheetId);
      var scrim = root.querySelector('[data-nv-scrim]');
      if (!sheet) return;
      lastFocus = opener || null;
      sheet.hidden = false;
      if (scrim) scrim.hidden = false;
      root.classList.add('is-open');
      if (window.matchMedia('(max-width: 1024px)').matches) document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          sheet.classList.add('is-open');
          var first = sheet.querySelector('.nv-on, a, button:not([data-nv-close]), input');
          if (first) first.focus({ preventScroll: true });
        });
      });
      if (opener) opener.setAttribute('aria-expanded', 'true');
    }

    function closeSheet(silent) {
      var open = root.querySelector('[data-nv-sheet].is-open');
      var scrim = root.querySelector('[data-nv-scrim]');
      root.querySelectorAll('[data-nv-open][aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      root.classList.remove('is-open');
      document.body.style.overflow = '';
      if (scrim) scrim.hidden = true;
      if (!open) return;
      open.classList.remove('is-open');
      setTimeout(function () { if (!open.classList.contains('is-open')) open.hidden = true; }, 260);
      if (!silent && lastFocus && document.body.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    }

    /* ---------- texto da categoria: Ler mais so quando o texto passa do box ---------- */
    function syncInfo() {
      root.querySelectorAll('[data-nv-info]').forEach(function (body) {
        var box = body.closest('.nv-col-info');
        var btn = box ? box.querySelector('[data-nv-info-toggle]') : null;
        if (!btn || box.classList.contains('is-open')) return;
        btn.hidden = body.scrollHeight <= body.clientHeight + 4;
      });
    }

    /* ---------- AJAX ---------- */
    function render(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-nv-col]');
      if (!fresh) return false;
      root.innerHTML = fresh.innerHTML;
      if (window.NV && typeof window.NV.wishlistSync === 'function') window.NV.wishlistSync(root);
      syncInfo();
      return true;
    }

    function go(href, push) {
      if (busy) return;
      var u = cleanUrl(href);
      busy = true;
      root.classList.add('nv-col-loading');
      closeSheet(true);
      fetch(sectionUrl(u, id), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          if (!render(html)) { window.location.href = u.toString(); return; }
          if (push !== false) history.pushState({ nvCol: true }, '', u.toString());
          var bar = root.querySelector('[data-nv-col-bar]');
          if (bar) {
            var y = bar.getBoundingClientRect().top + window.pageYOffset - offsetTop();
            if (window.pageYOffset > y) window.scrollTo({ top: y, behavior: 'smooth' });
          }
        })
        .catch(function () { window.location.href = u.toString(); })
        .then(function () { busy = false; root.classList.remove('nv-col-loading'); });
    }

    function loadMore(btn) {
      if (busy) return;
      var u = cleanUrl(btn.href);
      busy = true;
      btn.classList.add('nv-loading');
      btn.textContent = 'Carregando...';
      fetch(sectionUrl(u, id), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = root.querySelector('[data-nv-grid]');
          var newGrid = doc.querySelector('[data-nv-grid]');
          var more = root.querySelector('[data-nv-more]');
          var newMore = doc.querySelector('[data-nv-more]');
          if (!grid || !newGrid) { window.location.href = u.toString(); return; }
          var firstNew = newGrid.firstElementChild;
          while (newGrid.firstChild) grid.appendChild(newGrid.firstChild);
          if (more && newMore) {
            var prev = newMore.querySelector('.nv-col-prev');
            if (prev) prev.remove();
            more.innerHTML = newMore.innerHTML;
          }
          if (window.NV && typeof window.NV.wishlistSync === 'function') window.NV.wishlistSync(grid);
          if (firstNew) {
            var link = firstNew.querySelector('a');
            if (link) link.focus({ preventScroll: true });
          }
        })
        .catch(function () { window.location.href = u.toString(); })
        .then(function () { busy = false; });
    }

    /* ---------- eventos (delegados no root: sobrevivem ao re-render) ---------- */
    root.addEventListener('click', function (e) {
      var infoBtn = e.target.closest('[data-nv-info-toggle]');
      if (infoBtn) {
        var infoBox = infoBtn.closest('.nv-col-info');
        var infoOpen = infoBox.classList.toggle('is-open');
        infoBtn.setAttribute('aria-expanded', infoOpen ? 'true' : 'false');
        infoBtn.textContent = infoOpen ? 'Ler menos' : 'Ler mais';
        if (!infoOpen) {
          var ib = infoBox.querySelector('[data-nv-info]');
          if (ib) ib.scrollTop = 0;
        }
        return;
      }
      var opener = e.target.closest('[data-nv-open]');
      if (opener && root.contains(opener)) {
        e.preventDefault();
        var target = opener.getAttribute('data-nv-open');
        var isOpen = opener.getAttribute('aria-expanded') === 'true';
        if (isOpen) closeSheet(); else openSheet(target, opener);
        return;
      }
      if (e.target.closest('[data-nv-close]') || e.target.closest('[data-nv-scrim]')) {
        e.preventDefault();
        closeSheet();
        return;
      }
      var more = e.target.closest('[data-nv-loadmore]');
      if (more) {
        e.preventDefault();
        loadMore(more);
        return;
      }
      var link = e.target.closest('a[data-nv-link]');
      if (link && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
        e.preventDefault();
        go(link.href);
      }
    });

    root.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-nv-form]');
      if (!form) return;
      e.preventDefault();
      var fd = new FormData(form);
      if (e.submitter && e.submitter.name) fd.set(e.submitter.name, e.submitter.value);
      var u = new URL(form.getAttribute('action') || window.location.pathname, window.location.origin);
      fd.forEach(function (val, key) {
        if (val === '' || val == null) return;
        u.searchParams.append(key, val);
      });
      go(u.toString());
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) closeSheet();
    });

    syncInfo();
    window.addEventListener('load', syncInfo);
    window.addEventListener('resize', syncInfo);

    window.addEventListener('popstate', function () {
      if (window.location.pathname.indexOf('/collections/') !== -1 || window.location.pathname.indexOf('/search') !== -1) go(window.location.href, false);
    });
  }

  var ticking = false;
  function syncTop() {
    ticking = false;
    document.documentElement.style.setProperty('--nv-col-top', offsetTop() + 'px');
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(syncTop); }
  }

  function start() {
    var roots = document.querySelectorAll('[data-nv-col]');
    if (!roots.length) return;
    roots.forEach(init);
    syncTop();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
